var nacl = require('tweetnacl')
var assert = require('nanoassert')

var DHLEN = 32
var PKLEN = nacl.box.publicKeyLength
var SKLEN = nacl.box.secretKeyLength

function generateKeypair() {
  var keypair = nacl.box.keyPair()
  return {
    publicKey: Buffer.from(keypair.publicKey),
    secretKey: Buffer.from(keypair.secretKey)
  }
}

function dh(secretKey, publicKey) {
  assert(secretKey && secretKey.length === SKLEN)
  assert(publicKey && publicKey.length === PKLEN)
  return Buffer.from(nacl.scalarMult(secretKey, publicKey))
}

function fromSecretKey(secretKey) {
  var keypair = nacl.box.keyPair.fromSecretKey(secretKey)
  return {
    publicKey: Buffer.from(keypair.publicKey),
    secretKey: Buffer.from(keypair.secretKey)
  }
}

dh.DHLEN = DHLEN
dh.PKLEN = PKLEN
dh.SKLEN = SKLEN
dh.generateKeypair = generateKeypair
dh.keyPair = { fromSecretKey }

module.exports = dh